import { getField, updateField } from "vuex-map-fields";

const state = {
  toast: {
    show: false,
    message: "",
    color: "primary"
  }
};

const actions = {
  showSuccessMessage({ commit }, message) {
    commit("updateField", {
      path: "toast",
      value: {
        show: true,
        message,
        color: "success"
      }
    });
  },
  showErrorMessage({ commit }, message) {
    commit("updateField", {
      path: "toast",
      value: {
        show: true,
        message,
        color: "error"
      }
    });
  },
  showInfoMessage({ commit }, message) {
    commit("updateField", {
      path: "toast",
      value: {
        show: true,
        message,
        color: "primary"
      }
    });
  }
};

const mutations = {
  updateField
};

const getters = {
  getField
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
